module.exports = __webpack_public_path__ + "static/media/xyunknown.ea199762.svg";